import _PropTypes from 'prop-types';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useAccordionContext } from '../AccordionContext/AccordionContext.js';
import { DragAccordion } from './DragAccordion.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var AccordionDndContext = function AccordionDndContext(_ref) {
  var children = _ref.children,
      canDrag = _ref.canDrag,
      canDrop = _ref.canDrop,
      onDragChange = _ref.onDragChange;

  var _useAccordionContext = useAccordionContext(),
      $variant = _useAccordionContext.variant;

  var context = React.useMemo(function () {
    return {
      canOrder: true,
      canDrag: canDrag,
      canDrop: canDrop,
      onDragChange: onDragChange
    };
  }, [canDrag, canDrop, onDragChange]);
  return /*#__PURE__*/jsx(DndProvider, {
    backend: HTML5Backend,
    children: /*#__PURE__*/jsxs(Context.Provider, {
      value: context,
      children: [/*#__PURE__*/jsx(DragAccordion, {
        $variant: $variant
      }), children]
    })
  });
};

AccordionDndContext.propTypes = {
  "canDrag": _PropTypes.func,
  "canDrop": _PropTypes.func,
  "children": _PropTypes.node,
  "onDragChange": _PropTypes.func
};
AccordionDndContext.displayName = "AccordionDndContext";
function useAccordionDndContext() {
  return React.useContext(Context);
}
var accordionDragType = "accordion";

export { AccordionDndContext, accordionDragType, useAccordionDndContext };
